import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3afb9b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-blocks-section" }
const _hoisted_2 = { class: "time-blocks-container" }
const _hoisted_3 = ["onMousedown", "onMouseenter"]
const _hoisted_4 = { class: "time-label" }

import {
  computed,
  ref,
  onMounted,
  watch,
  nextTick,
} from 'vue'
import type { ElTable } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { ElecTariff } from '@/types/types'

interface RateItem {
  tag: number
  name: string
  elecFee: number
  servicePrice: number
}

interface ColorStyle {
  name: string
  bg: string
  text: string
  border: string
}

interface TimeBlock {
  tag: number | null
}


import { defineComponent, PropType } from 'vue'

const __default__ = defineComponent({
  name: 'PriceingTariffElecV2',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Array as PropType<ElecTariff[]>,
    required: false,
    default: () => [],
  },
  supportDeepValley: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { expose, emit }) {

const props = __props




expose({
  validate: async () => {
    await nextTick()
    return true
  },
})

const elecTariffs = computed<ElecTariff[]>({
  get: () => {
    console.log('elecTariffs:', props.modelValue)
    return props.modelValue
  },
  set: (val: any) => {
    emit('update:modelValue', val)
  },
})

const { t } = useI18n()

// 固定表格数据
const tableData = computed<RateItem[]>(() => {
  const table = [
    { tag: 1, name: t(`Operation.priceingTariffSharp`), elecFee: 0, servicePrice: 0 },
    { tag: 2, name: t(`Operation.priceingTariffPeak`), elecFee: 0, servicePrice: 0 },
    { tag: 3, name: t(`Operation.priceingTariffFlat`), elecFee: 0, servicePrice: 0 },
    { tag: 4, name: t(`Operation.priceingTariffValley`), elecFee: 0, servicePrice: 0 },
  ]
  if (props.supportDeepValley) {
    table.push({
      tag: 5,
      name: t(`Operation.priceingTariffDeepValley`),
      elecFee: 0,
      servicePrice: 0,
    })
  }
  return table
})

watch(
  () => props.supportDeepValley,
  (val) => {
    if (!val) {
      elecTariffs.value = elecTariffs.value.filter((item) => item.tag !== 5)
    }
  },
)
// 48个时间块 (24小时 * 2 = 48个半小时块)
const timeBlocks = ref<TimeBlock[]>(Array.from({ length: 48 }, () => ({ tag: null })))

// 当前选中的行
const currentRow = ref<RateItem | null>(null)
const tableRef = ref<InstanceType<typeof ElTable>>()

// 颜色配置
const colorConfig: Record<number, ColorStyle> = {
  0: {
    name: '未选择',
    bg: '#f5f5f5',
    text: '#9e9e9e',
    border: '1px solid #e0e0e0',
  },
  1: {
    name: t(`Operation.priceingTariffSharp`),
    bg: 'rgba(255, 235, 238, 0.7)',
    text: '#d32f2f',
    border: '1px solid #d32f2f',
  },
  2: {
    name: t(`Operation.priceingTariffPeak`),
    bg: 'rgba(255, 243, 224, 0.7)',
    text: '#ff8f00',
    border: '1px solid #ff8f00',
  },
  3: {
    name: t(`Operation.priceingTariffFlat`),
    bg: 'rgba(232, 245, 233, 0.7)',
    text: '#388e3c',
    border: '1px solid #388e3c',
  },
  4: {
    name: t(`Operation.priceingTariffValley`),
    bg: 'rgba(227, 242, 253, 0.7)',
    text: '#1976d2',
    border: '1px solid #1976d2',
  },
  5: {
    name: t(`Operation.priceingTariffDeepValley`),
    bg: 'rgba(176, 196, 222, 0.7)', // Light Steel Blue with transparency
    text: '#4682B4', // Steel Blue
    border: '1px solid #4682B4', // Steel Blue
  },
}

// 根据当前选中行计算样式
const currentRowStyle = computed(() => {
  if (!currentRow.value) return {}

  const colors = colorConfig[currentRow.value.tag]
  return {
    backgroundColor: colors.bg,
    color: colors.text,
    borderLeft: colors.border,
  }
})

// 处理行点击事件
const handleRowClick = (row: RateItem) => {
  currentRow.value = row
}

// 获取行类名
const getRowClassName = ({ row }: { row: RateItem }) => {
  return currentRow.value?.tag === row.tag ? `selected-row tag-${row.tag}` : ''
}

// 电费变化处理
const handleElecFeeChange = (row: RateItem) => {
  console.log(`Tag ${row.tag} 电费修改为:`, row.elecFee)
  updateTariffs()
}

// 服务费变化处理
const handleServicePriceChange = (row: RateItem) => {
  console.log(`Tag ${row.tag} 服务费修改为:`, row.servicePrice)
  updateTariffs()
}

// 格式化时间标签
// const formatTimeLabel = (index: number) => {
//   const hour = Math.floor(index / 2)
//   const minute = (index % 2) * 30
//   return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`
// }

const formatTimeLabel = (index: number) => {
  const startHour = Math.floor(index / 2)
  const startMinute = (index % 2) * 30
  const endHour = Math.floor((index + 1) / 2)
  const endMinute = ((index + 1) % 2) * 30

  return `${startHour.toString().padStart(2, '0')}:${startMinute
    .toString()
    .padStart(2, '0')}\n-\n${endHour.toString().padStart(2, '0')}:${endMinute
    .toString()
    .padStart(2, '0')}`
}

// 选择状态
const isSelecting = ref(false)
const selectionStartIndex = ref<number | null>(null)
const selectionEndIndex = ref<number | null>(null)

// 判断时间块是否在选择范围内
const isInSelectionRange = (index: number) => {
  if (
    !isSelecting.value ||
    selectionStartIndex.value === null ||
    selectionEndIndex.value === null
  ) {
    return false
  }
  const start = Math.min(selectionStartIndex.value, selectionEndIndex.value)
  const end = Math.max(selectionStartIndex.value, selectionEndIndex.value)
  return index >= start && index <= end
}

// 开始选择时间块
const startSelection = (index: number) => {
  if (!currentRow.value) return

  isSelecting.value = true
  selectionStartIndex.value = index
  selectionEndIndex.value = index // 初始化结束索引
}

// 处理鼠标进入时间块
const handleMouseEnter = (index: number) => {
  if (!isSelecting.value || selectionStartIndex.value === null) return

  // 只更新结束索引，不立即更新时间块
  selectionEndIndex.value = index
}
// 结束选择
const endSelection = () => {
  if (
    !isSelecting.value ||
    selectionStartIndex.value === null ||
    selectionEndIndex.value === null
  ) {
    isSelecting.value = false
    return
  }

  // 计算选择范围
  const start = Math.min(selectionStartIndex.value, selectionEndIndex.value)
  const end = Math.max(selectionStartIndex.value, selectionEndIndex.value)

  // 更新时间块
  updateTimeBlock(start, end, currentRow.value!.tag)

  // 重置选择状态
  isSelecting.value = false
  selectionStartIndex.value = null
  selectionEndIndex.value = null

  // 更新电价数据
  updateTariffs()
}

// 更新时间块
const updateTimeBlock = (start: number, end: number, tag: number) => {
  const newBlocks = [...timeBlocks.value]
  for (let i = start; i <= end; i++) {
    newBlocks[i] = { tag }
  }
  timeBlocks.value = newBlocks
}

// 默认选中第一行
onMounted(() => {
  if (tableRef.value && tableData.value.length > 0) {
    currentRow.value = tableData.value[0]
  }
})
// 初始化时间块
const initializeTimeBlocks = () => {
  if (!props.modelValue) return

  // 创建新的48个时间块数组
  const newBlocks = Array.from({ length: 48 }, () => ({ tag: null }))

  // 应用传入的时段配置
  elecTariffs.value?.forEach((tariff) => {
    // 确保时间范围有效
    const start = Math.max(0, Math.min(47, tariff.timeStart))
    const end = Math.max(1, Math.min(48, tariff.timeEnd))

    for (let i = start; i < end; i++) {
      newBlocks[i].tag = tariff.tag
    }
  })

  timeBlocks.value = newBlocks
}

// 初始化时段价格
const initializeRatePrices = () => {
  // 创建价格数据副本

  const newTableData = [...tableData.value]

  // 应用传入的价格配置
  props.modelValue?.forEach((tariff) => {
    const rateIndex = newTableData.findIndex((r) => r.tag === tariff.tag)
    if (rateIndex >= 0) {
      newTableData[rateIndex].elecFee = tariff.price
      newTableData[rateIndex].servicePrice = tariff.servicePrice
    }
  })

  tableData.value = newTableData
}
// 生成最终的电价时段数据并emit
const updateTariffs = () => {
  try {
    const tariffs: ElecTariff[] = []

    // 确保 timeBlocks.value 存在且是数组
    if (!timeBlocks.value || !Array.isArray(timeBlocks.value)) {
      console.error('timeBlocks.value is not valid:', timeBlocks.value)
      return
    }

    // 为每个时段(1-5)生成时间范围
    ;[1, 2, 3, 4, 5].forEach((tag) => {
      // 从 tableData 中获取当前时段的价格
      const rateItem = tableData.value.find((item) => item.tag === tag)
      if (!rateItem) return

      let start: number | null = null

      // 遍历时间块
      for (let i = 0; i < timeBlocks.value.length; i++) {
        const block = timeBlocks.value[i]
        if (!block) continue

        if (block.tag === tag) {
          if (start === null) start = i
        } else {
          if (start !== null) {
            tariffs.push({
              timeStart: start,
              timeEnd: i,
              tag: tag,
              price: rateItem.elecFee,
              servicePrice: rateItem.servicePrice,
            })
            start = null
          }
        }
      }

      // 处理最后一个时段
      if (start !== null) {
        tariffs.push({
          timeStart: start,
          timeEnd: timeBlocks.value.length,
          tag,
          price: rateItem.elecFee,
          servicePrice: rateItem.servicePrice,
        })
      }
    })

    console.log('更新后的电价数据:', tableData.value)
    console.log('更新后的电价时段数据:', tariffs)
    emit('update:modelValue', tariffs)
  } catch (error) {
    console.error('更新电价时段数据时出错:', error)
  }
}

// 统一初始化
const initializeData = () => {
  initializeTimeBlocks()
  initializeRatePrices()
}

// 监听props变化
watch(() => props.modelValue, initializeData, { immediate: true, deep: true })

// 组件挂载时初始化
onMounted(initializeData)

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "topicForm",
    "validate-on-rule-change": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        ref_key: "tableRef",
        ref: tableRef,
        data: _unref(tableData),
        style: {"width":"100%"},
        onRowClick: handleRowClick,
        "row-class-name": getRowClassName
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: _ctx.$t('Operation.priceingTariffTag'),
            width: "120"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "elecFee",
            label: _ctx.$t('Operation.priceingTariffElecFee')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_input_number, {
                modelValue: row.elecFee,
                "onUpdate:modelValue": ($event: any) => ((row.elecFee) = $event),
                min: 0,
                precision: 3,
                controls: false,
                onChange: ($event: any) => (handleElecFeeChange(row))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "servicePrice",
            label: _ctx.$t('Operation.priceingTariffServiceFee')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_input_number, {
                modelValue: row.servicePrice,
                "onUpdate:modelValue": ($event: any) => ((row.servicePrice) = $event),
                min: 0,
                precision: 3,
                controls: false,
                onChange: ($event: any) => (handleServicePriceChange(row))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"]),
      (currentRow.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "selection-info",
            style: _normalizeStyle(_unref(currentRowStyle))
          }, _toDisplayString(_unref(t)(`Operation.priceingTariffTimeSelect`)) + " " + _toDisplayString(currentRow.value.name) + " . " + _toDisplayString(_unref(t)(`Operation.priceingTariffTimeSelectTip`)), 5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (row) => {
            return _createElementVNode("div", {
              key: row,
              class: "time-blocks-row"
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (col) => {
                return _createElementVNode("div", {
                  key: col,
                  class: _normalizeClass(["time-block", [
              `time-block-${timeBlocks.value[(row - 1) * 12 + (col - 1)].tag || 'unselected'}`,
              {
                selecting: isSelecting.value && isInSelectionRange((row - 1) * 12 + (col - 1)),
              },
            ]]),
                  onMousedown: ($event: any) => (startSelection((row - 1) * 12 + (col - 1))),
                  onMouseenter: ($event: any) => (handleMouseEnter((row - 1) * 12 + (col - 1))),
                  onMouseup: endSelection
                }, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(formatTimeLabel((row - 1) * 12 + (col - 1))), 1)
                ], 42, _hoisted_3)
              }), 64))
            ])
          }), 64))
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})